module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00308.17231cfb.jpg";